import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';
import Material from '@primeng/themes/material';
import Nora from '@primeng/themes/nora';
import Lara from '@primeng/themes/lara';

export const ClientQuest = definePreset(Aura, {
    semantic: {
        primary: {
            50: "#FDE9EE",
            100: "#FBC8D6",
            200: "#F7A3B9",
            300: "#F37E9C",
            400: "#EF5A80",
            500: "#E43F6F", // Base color
            600: "#B83257",
            700: "#8A2643",
            800: "#5C1A2F",
            900: "#2E0D1A",
            950: "#19060D"
        }
    }
});